import { styledComponent } from '@hermes/web-components'

export const RollLabel = styledComponent('span', {
  shouldForwardProp: (prop: string) => !['decreasedFontSize', 'isAnimating', 'gradient'].includes(prop)
})<{
  decreasedFontSize?: boolean
  isAnimating?: boolean
  gradient: string
}>(({ theme, decreasedFontSize, isAnimating, gradient }) => ({
  background: gradient,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  display: 'inline-block',
  animation: isAnimating ? 'rollAnimation 1s ease' : 'none',

  '@keyframes rollAnimation': {
    '0%': {
      transform: 'translateY(0)'
    },
    '45%': {
      transform: 'translateY(-20%)',
      opacity: 0
    },
    '55%': {
      transform: 'translateY(30%)',
      opacity: 0
    },
    '100%': {
      transform: 'translateY(0)',
      opacity: 1
    }
  },

  [theme.breakpoints.up('sm')]: {
    whiteSpace: 'nowrap'
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: decreasedFontSize ? '30px' : '',
    lineHeight: '48px'
  },
  [theme.breakpoints.down('md')]: {
    width: '100%'
  }
}))
